import {
    OBTENER_CLIENTES,
    OBTENER_CLIENTE,
    AGREGAR_CLIENTE,
    ELIMINAR_CLIENTE,
    ACTUALIZAR_CLIENTE,
    ROL_CLIENTE,
    ELIMINAR_ROL_CLIENTE,
    OBTENER_CLIENTES_SOPORTE,
    CLIENTE_ERROR,
    CLIENTE_OK,
    CLIENTE_ACTUAL,
    OBTENER_ROLES
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_ROLES:
            return {
                ...state,
                roles:action.payload
            }
        case OBTENER_CLIENTES:
            return {
                ...state,
                clientes: action.payload.rows
            }
        case OBTENER_CLIENTE:
            return {
                ...state,
                cliente: action.payload.rows
            }
        case OBTENER_CLIENTES_SOPORTE:
            return {
                ...state,
                clientes: action.payload
            }
        case CLIENTE_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case CLIENTE_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_CLIENTE:
            return {
                ...state,
                clientes: [...state.clientes, action.payload],
                formulario: false,
                errorformulario: false
            }
        case ROL_CLIENTE:
            return {
                ...state,
                clientes: state.clientes.map(cli => cli.id === action.payload.idCliente ? action.payload : cli),
                cliente: action.payload
            }
        case CLIENTE_ACTUAL:
            return {
                ...state,
                cliente: state.clientes.find(cli => cli.id === action.payload)
            }
        case ELIMINAR_CLIENTE:
            return {
                ...state,
                clientes: state.clientes.filter(cli => cli.id !== action.payload),
                cliente: null
            }
        case ACTUALIZAR_CLIENTE:
            return {
                ...state,
                clientes: state.clientes.map(cli => cli.id === action.payload.id ? action.payload : cli),
                cliente: action.payload
            }
        case ELIMINAR_ROL_CLIENTE:
            return true;
        default:
            return state;
    }
}